<!-- 
  @desc 全国青少年体育赛事备案
-->
<template>
  <record></record>
</template>
<script>
import Record from "@/components/record/Index.vue";
export default {
  components: {
    Record
  }
};
</script>
<style lang="scss"></style>
